import {Component} from '@angular/core';

import {I18nModule} from '@spartacus/core';
import {GenericConfiguratorErrorComponent} from '../product/configurator/error-handling/generic-configurator-error/generic-configurator-error.component';

@Component({
  selector: 'dcp-redundant-homepage',
  templateUrl: './redundant-homepage.component.html',
  styleUrls: ['./redundant-homepage.component.scss'],
  imports: [I18nModule, GenericConfiguratorErrorComponent],
  standalone: true,
})
export class RedundantHomepageComponent {}
